/**
 * useSupportTicket
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'
import SupportTicketContext from './support-ticket-context'

const useSupportTicket = () => {
  const context = useContext(SupportTicketContext)
  return context
}

export default useSupportTicket
